import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2017-11-27",
    disableHostPrefix: false,
    signingName: "comprehend",
    regionInfoProvider: defaultRegionInfoProvider
};
//# sourceMappingURL=runtimeConfig.shared.js.map